import queryString from 'query-string'

export const DEVICE_REGISTER = (data) => {
    return "/device/register?" + queryString.stringify(data, {encode: true})
}
export const CONTACT_RESEARCH_ASSISTANT = (id) => {
    return "/device/" + id + "/contact"
}
export const RECORD_ACTIVITY = (id) => {
    return "/device/" + id + "/activity"
}
export const CONTACT_MORE_INFORMATION = (id) => {
    return "/device/" + id + "/moreinformation"
}

export const DEVICE_SURVEY = (id, surveyId, stepId) => {
    return "/device/" + id + "/survey/" + surveyId + "/step/" + stepId
}
export const DEVICE_SURVEY_START = (id) => {
    return "/device/" + id + "/survey/start"
}
export const DEVICE_SURVEY_STEP = (id) => {
    return "/device/" + id + "/survey/step"
}
export const DEVICE_SURVEY_PREVIOUS_STEP = (id, surveyId) => {
    return "/device/" + id + "/survey/" + surveyId + "/step/back"
}
